import React from 'react';

import EditIcon from '../EditIcon';
import { IconSwitcherProps } from '../types';

const IconSwitcher: React.FC<IconSwitcherProps> = ({
  icon: Icon = EditIcon,
  ...props
}) => {
  return <Icon {...props} />;
};

export default IconSwitcher;
